import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { getURLSegment } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import ReactAutolinker from 'react-autolinker';

// Components
import TicketForm from './TicketForm'

const SupportTicketDetail = observer(class SupportTicketDetail extends React.Component {
  constructor() {
    super();
    this.renderConversation = this.renderConversation.bind(this);
  }

  componentWillMount() {
    const { TicketStore } = this.props.store;
    const ticketSid = getURLSegment(this, 3);

    TicketStore.getTicket(ticketSid);
  }

  initials(name, className) {
    const names = name.split(' ');
    const firstInitial = names[0].charAt(0);
    const secondInitial = names[1].charAt(0);

    if(className) {
      return `${firstInitial.toLowerCase()}`
    }

    return firstInitial + secondInitial;
  }

  renderConversation() {
    const { store, translation } = this.props;
    const { SessionStore, TicketStore } = store;
    const { activeTicket } = TicketStore;
    const { requester } = activeTicket;

    const linkOptions = {
      target: '_blank'
    }

    if(!SessionStore.loading ) {
      return (
        <ol className="conversation">
          <li>
            <blockquote className="conversation__message sent">
              <div className="conversation__body">
                <div className="conversation__content">
                  <ReactAutolinker
                    text={activeTicket.descriptionText}
                    options={linkOptions}
                  />
                </div>
                <time className="conversation__timestamp">{moment(activeTicket.createdDate).format('M/D/YYYY h:mma')}</time>
              </div>

              <cite className="conversation__author conversation__author--sm">
                <abbr
                  className={`
                    avatar--initials conversation__avatar ${this.initials(requester.firstName + ' ' + requester.lastName, true)}
                  `}
                  title={`${requester.firstName} ${requester.lastName}`}>
                  {requester.firstName.charAt(0)}{requester.lastName.charAt(0)}
                </abbr>

                {requester.role === 'admin' &&
                  <em className="conversation__tag">{translation.admin}</em>
                }
              </cite>
            </blockquote>
          </li>
          {activeTicket.conversations.map(
            (key, i) =>
            <li key={i}>
              <blockquote className={`conversation__message ${key.jobTitle !== null ? 'received' : 'sent'}`}>
                <div className="conversation__body">
                  <div className="conversation__content">
                    {key.bodyText}

                    {/* <ReactAutolinker
                      text={key.bodyText}
                      options={linkOptions}
                    /> */}
                  </div>
                  <time className="conversation__timestamp">{moment(key.created_at).format('M/D/YYYY h:mma')}</time>
                </div>

                <cite className="conversation__author conversation__author--sm">
                  <abbr
                    className={`
                      avatar--initials
                      conversation__avatar
                      ${this.initials(key.name, true)}
                    `}
                    title={`${key.name}`}>
                    {this.initials(key.name, false)}
                  </abbr>

                  {key.jobTitle !== null &&
                    <em className="conversation__tag">{translation.admin}</em>
                  }
                </cite>
              </blockquote>
            </li>
          )}
        </ol>
      )
    }

    return '';
  }

  render() {
    const { store, translation } = this.props;
    const { SessionStore, TicketStore } = store;
    const { activeTicket } = TicketStore;

    if(!SessionStore.loading) {
      return(
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.heading}{activeTicket.ticketNumber}</h1>
            </div>
          </header>

          <div className="wrap">
            <article className="ticket">
              <header className="ticket__header">
                <h3>{activeTicket.subject}</h3>
                <span className={`pill pill--${activeTicket.status.toLowerCase()}`}>{activeTicket.status}</span>
              </header>

              {this.renderConversation()}
            </article>

            <TicketForm activeTicket={activeTicket} {...this.props} />
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('SupportTicketDetail')(SupportTicketDetail);


// WEBPACK FOOTER //
// ./src/app/components/SupportTickets/SupportTicketDetail.js